import styles from './AC.module.scss';
import beian from '../../static/home/beian.png';
const Bottom = () => {
  return (
    <div className={styles.btns}>
      <div style={{
        height: '30px',
      }}>
        <span>中体联(北京)认证服务有限公司 </span>
        <a
          style={{ color: '#fff' }}
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          版权所有（京ICP备2024090111号-2）
        </a>
      </div>
      <div style={{
        height: '30px',
       
      }}>
      <img src={beian} alt={'备案'} style={{width: '20px', height: '20px', marginRight: '5px',verticalAlign: 'text-bottom'}}/>
        <a
          style={{ color: '#fff' }}
          href="https://beian.mps.gov.cn/#/query/webSearch?code=11010102007436"
          target="_blank"
          rel="noreferrer"
        >
        京公网安备11010102007436号
        </a>
      </div>
    </div>
  );
};

export default Bottom;
